/* ============================================================
   NOAIRE V — theme interactivity
   Cart drawer + AJAX cart, quick-add, variant picker,
   FAQ accordion, mobile nav, toast.
   Vanilla JS, no dependencies.
   ============================================================ */
(function () {
  'use strict';

  var money = function (cents) {
    // Shopify passes the shop currency format via data attribute on <body>.
    var fmt = document.body.getAttribute('data-money-format') || '£{{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
  };

  // Cart data is injected into innerHTML below. Escape it: a product title
  // containing markup would otherwise be executed as HTML.
  var esc = function (s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  };

  // Basket fixes 19 Oct: discount title(s) under a cart line, e.g. "3 for £60 ... applied".
  var discountTitles = function (item) {
    var allocs = item.line_level_discount_allocations || [];
    var list = allocs.length
      ? allocs.map(function (a) { return { amount: a.amount, title: a.discount_application && a.discount_application.title }; })
      : (item.discounts || []);
    return list.filter(function (d) { return d.amount > 0 && d.title; })
      .map(function (d) { return '<div class="cl-discount">' + esc(String(d.title).split(' (')[0]) + ' applied</div>'; }).join('');
  };

  var toast = function (msg) {
    var el = document.querySelector('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  };

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('.cart-drawer');
  var overlay = document.querySelector('.cart-overlay');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); renderCart(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); }
    if (e.target === overlay) closeCart();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* ---------- Fetch + render cart ---------- */
  function updateCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (n) {
      n.textContent = count;
      n.setAttribute('data-count', count);
    });
    updateBundle(count);
  }

  function renderCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        var itemsEl = document.querySelector('.cart-items');
        var footEl = document.querySelector('.cart-foot');
        if (!itemsEl) return;
        if (cart.item_count === 0) {
          itemsEl.innerHTML = '<div class="cart-empty">Your cart is empty.<br>The Debut Collection is waiting.</div>';
          if (footEl) footEl.style.display = 'none';
          return;
        }
        if (footEl) footEl.style.display = '';
        itemsEl.innerHTML = cart.items.map(function (item) {
          var img = item.image ? item.image.replace(/(\.[^.]+)(\?.*)?$/, '_120x$1') : '';
          var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
          return '' +
            '<div class="cart-line" data-key="' + esc(item.key) + '">' +
              (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span></span>') +
              '<div>' +
                '<div class="cl-name">' + esc(item.product_title) + '</div>' +
                (variant ? '<div class="cl-variant">' + esc(variant) + '</div>' : '') +
                discountTitles(item) +
                '<div class="cl-qty">' +
                  '<button data-qty-down aria-label="Decrease quantity">&minus;</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button data-qty-up aria-label="Increase quantity">+</button>' +
                '</div>' +
              '</div>' +
              '<div style="text-align:right">' +
                '<div class="cl-price">' +
                  (item.original_line_price > item.final_line_price ? '<s class="cl-was">' + money(item.original_line_price) + '</s>' : '') +
                  '<span class="cl-now">' + money(item.final_line_price) + '</span>' +
                '</div>' +
                '<button class="cl-remove" data-remove>Remove</button>' +
              '</div>' +
            '</div>';
        }).join('');
        var scope = drawer || document;
        var sub = scope.querySelector('.cart-foot .s-val');
        if (sub) sub.textContent = money(cart.total_price);
        // Basket fixes 19 Oct: savings row + delivery line (free UK delivery at £60+).
        var save = scope.querySelector('[data-cart-savings]');
        if (save) {
          save.hidden = !(cart.total_discount > 0);
          var sv = save.querySelector('[data-cart-savings-val]');
          if (sv) sv.textContent = money(cart.total_discount);
        }
        var del = scope.querySelector('[data-cart-delivery]');
        if (del) del.innerHTML = cart.total_price >= 6000 ? 'Free UK delivery' : 'UK delivery £3.99 &middot; free on orders of £60+';
      });
  }

  /* ---------- Bundle offer strip ----------
     Reads the live cart and tells the shopper how far off the bundle they are.
     A static badge says the offer exists; "add 1 more" says they are one tap
     from it, which is the whole point of the strip. */
  var BUNDLE_DISMISSED = 'noairev:bundle-dismissed';

  function updateBundle(count) {
    // Two copies exist: the mobile sticky bar and the desktop inline one. CSS
    // decides which is visible, so both are kept in sync rather than guessing.
    var strips = document.querySelectorAll('[data-bundle-strip]');
    if (!strips.length) return;

    var dismissed = false;
    try { dismissed = sessionStorage.getItem(BUNDLE_DISMISSED) === '1'; } catch (e) { /* private mode: just show it */ }

    strips.forEach(function (strip) {
      if (dismissed) { strip.hidden = true; return; }
      paintBundle(strip, count);
    });
  }

  function paintBundle(strip, count) {
    var need = parseInt(strip.getAttribute('data-bundle-qty'), 10) || 3;
    var label = strip.getAttribute('data-bundle-label') || '';
    var code = (strip.getAttribute('data-bundle-code') || '').trim();
    var textEl = strip.querySelector('[data-bundle-text]');
    var cta = strip.querySelector('[data-bundle-cta]');
    var remaining = need - count;

    if (remaining <= 0) {
      strip.classList.add('is-unlocked');
      textEl.innerHTML = code
        ? 'Unlocked. Use code <b>' + esc(code) + '</b> at checkout'
        : '<b>' + esc(label) + '</b> unlocked';
      cta.textContent = 'View cart';
      cta.href = '/cart';
      cta.hidden = false;
    } else if (count === 0) {
      strip.classList.remove('is-unlocked');
      textEl.innerHTML = 'Any <b>' + esc(label) + '</b>';
      cta.hidden = true;
    } else {
      strip.classList.remove('is-unlocked');
      textEl.innerHTML = 'Add ' + remaining + ' more &middot; <b>' + esc(label) + '</b>';
      cta.textContent = 'Shop';
      cta.href = strip.getAttribute('data-bundle-url') || '/collections/all';
      cta.hidden = false;
    }
    strip.hidden = false;
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-bundle-dismiss]')) return;
    document.querySelectorAll('[data-bundle-strip]').forEach(function (s) { s.hidden = true; });
    try { sessionStorage.setItem(BUNDLE_DISMISSED, '1'); } catch (err) {}
  });

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var line = e.target.closest('.cart-line');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var qtyEl = line.querySelector('.cl-qty span');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (e.target.closest('[data-qty-up]')) changeLine(key, qty + 1);
    if (e.target.closest('[data-qty-down]')) changeLine(key, Math.max(0, qty - 1));
    if (e.target.closest('[data-remove]')) changeLine(key, 0);
  });

  /* ---------- Add to cart (product form + quick add) ---------- */
  function addToCart(id, qty, btn) {
    if (btn) { btn.setAttribute('disabled', ''); btn._label = btn.textContent; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        renderCart();
        openCart();
        if (btn) { btn.removeAttribute('disabled'); btn.textContent = btn._label; }
      })
      .catch(function (err) {
        toast((err && err.description) || 'Sorry, that could not be added.');
        if (btn) { btn.removeAttribute('disabled'); btn.textContent = btn._label; }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!idInput || !idInput.value) { toast('Please choose a size first.'); return; }
    addToCart(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) : 1, form.querySelector('[type="submit"]'));
  });

  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    addToCart(qa.getAttribute('data-variant-id'), 1, qa);
  });

  /* ---------- Variant picker (product page) ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('[data-product-form]') || document;
    var idInput = form.querySelector ? form.querySelector('[name="id"]') : null;
    var priceEls = document.querySelectorAll('[data-product-price]');
    var variants = JSON.parse(picker.getAttribute('data-variants') || '[]');

    function select(variantId) {
      var v = variants.filter(function (x) { return String(x.id) === String(variantId); })[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      priceEls.forEach(function (el) { el.textContent = money(v.price); });
      var atc = form.querySelector ? form.querySelector('[data-atc]') : null;
      if (atc) {
        if (v.available) { atc.removeAttribute('disabled'); atc.textContent = atc.getAttribute('data-add-label') || 'Add to cart'; }
        else { atc.setAttribute('disabled', ''); atc.textContent = 'Sold out'; }
      }
    }
    picker.addEventListener('change', function (e) {
      if (e.target.matches('[name="variant"]')) select(e.target.value);
    });
    var checked = picker.querySelector('[name="variant"]:checked');
    if (checked) select(checked.value);
  });

  /* ---------- FAQ accordion ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.faq-question');
    if (!q) return;
    var item = q.closest('.faq-item');
    var answer = item.querySelector('.faq-answer');
    var open = item.classList.toggle('is-open');
    q.setAttribute('aria-expanded', open ? 'true' : 'false');
    answer.style.maxHeight = open ? answer.querySelector('.faq-answer-inner').scrollHeight + 'px' : '0';
  });

  /* ---------- Mobile nav ---------- */
  var mobileNav = document.querySelector('.mobile-nav');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { if (mobileNav) mobileNav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    if (e.target.closest('[data-menu-close]') || e.target.closest('.mobile-nav a')) { if (mobileNav) mobileNav.classList.remove('is-open'); document.body.style.overflow = ''; }
  });

  /* ---------- Init count on load ---------- */
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCount(cart.item_count); })
    .catch(function () {});
})();
